<template>
<div v-if="list && list.length">
  <bread-crumb :vector="[{fa : ' محبوب ترین محصولات در فروشگاه '+supplierName,path : '/Category/'+route.params.supplier_id}]" v-if="supplierName"/>
  <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-2" v-if="list && supplierTemplate == 1">
      <div class="sc-d8w7bo-1 jpdybm">
          <div class="d-flex flex-wrap" style="padding-inline: 3px;gap: 1px;">
              <product-border :list="list" />
          </div>
      </div>
  </section>
  <section v-else-if="list && supplierTemplate == 2" class="article-template mt-2">
      <article class="d-flex align-items-top px-1 py-3 border-bottom border-end position-relative" style="background-color: white;" v-for="(bitem,index) in list" :key="bitem.id" >
          <img :src="'https://radap.ir/' + bitem.img_url.split(',')[0]" style="width:25%;max-width: 100px;max-height: 100px;" class="rounded" @click="goProductPage(bitem.id)" />
          <div style="width:75%" class="px-2 product-info-temp">
          <div class="d-flex justify-content-between" style="height: 30px;">
              <p style="max-height: 30px; font-size: 16px;font-weight: 600;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" @click="goProductPage(bitem.id)">{{ bitem.name}}</p>
              <button-template :id="bitem.id" :sid="bitem.store_place_id" :quantity="bitem.quantity" origin="basket" v-if="bitem.store_active == 0" />
              <span v-else class="text-light px-1 bg-red  rounded d-flex bg-secondary" style="height: 24px;justify-content: center;align-items: center;font-size: 10px;width:fit-content;min-width:fit-content;left:0">فروشگاه بسته است</span>
          </div>
              <small class="pt-1 d-block description-temp"  v-if="bitem.description" @click="goProductPage(bitem.id)">{{ bitem.description}}</small>
              <footer class=" d-flex justify-content-between align-items-center" @click="goProductPage(bitem.id)">
              <div class="d-flex flex-wrap mt-1">
                  <del class="text-muted" style="margin-left: 5px;font-size: 14px;" v-if="bitem.discount > 0">{{convertToPersian(String(bitem.price)) }}</del>
                  <strong style="margin-left: 5px; border: 1px solid red; border-radius: 5px; padding: 2px; color: red;font-size: 14px;" v-if="bitem.discount > 0"  :class="{ 'peculiar-discount': bitem.discount > 4 }"><small style="font-size: smaller;">%</small>{{convertToPersian(String(bitem.discount)) }}</strong>
                  <strong style="margin-left: 5px;font-size: 14px">{{convertToPersian(numberFormat((parseInt(removeCommos(bitem.price)) - (parseInt(removeCommos(bitem.price)) * (parseInt(bitem.discount) / 100)))))}}<small class="pr-1" style="font-size: 12px">تومان</small></strong>
              </div>
              </footer>
          </div>
      </article>
  </section>
</div>
<Loading v-else page="group" />
</template>
<script setup>
import {ref,defineProps} from 'vue'
import { useRoute, useRouter } from 'vue-router';
import ProductBorder from '@/components/section/item/ProductBorder.vue';
import BreadCrumb from '@/components/section/item/BreadCrumb.vue';
import ButtonTemplate from '@/components/section/item/button.vue'
import Loading from "../../../../section/item/loading.vue";

import { convertToPersian, numberFormat, removeCommos } from '@/composables/digits';
const route = useRoute()
let router = useRouter()
let list = ref([]);
let supplierName = ref('');
let supplierTemplate = ref();
getItems()
async function getItems(){
let response = await fetch('https://radap.ir/Backend/api/section/pages/store/whole_best.php?id='+route.params.supplier_id)
let data = await response.json()
    list.value = data.items;
    supplierName.value = data.supplier_name;
    supplierTemplate.value = data.supplier_template_type;
    window.scrollTo(0,0)
}
function goProductPage(id){
    router.push({name:'Single',params:{item:id}})
}
</script>

<style scoped>

.description-temp{
  text-align: justify;
  padding-left: .25em;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 40px;
   font-size: 13px;
   -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}
article{
  width: 100%;
}
@media (min-width : 650px){
  .article-template{
    display: flex;
    flex-wrap: wrap;
  }
  article{
    width: 50%;
  }
}

</style>